import { Box } from '@mui/material';
import { Submission } from '../../submission-graphql';
import SubmissionOverviewButtons from './SubmissionOverviewButtons';
import SubmissionOverviewInfo from './SubmissionOverviewInfo';

const LAYOUT = {
  BUTTONS_MAX_WIDTH: 400,
  BUTTONS_MAX_PERCENT: 20,
};

interface SubmissionOverviewHeaderProps {
  submission: Submission;
  goToInfoUpdate(): void;
  createNewGameBuild(): void;
}

const SubmissionOverviewHeader: React.FC<SubmissionOverviewHeaderProps> = ({
  goToInfoUpdate,
  createNewGameBuild,
}: SubmissionOverviewHeaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%',
        gap: 2,
        pb: 2,
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
        }}
      >
        <SubmissionOverviewInfo />
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          flexGrow: 0,
          width: 'auto',
          maxWidth: `min(${LAYOUT.BUTTONS_MAX_WIDTH}px, ${LAYOUT.BUTTONS_MAX_PERCENT}%)`,
        }}
      >
        <SubmissionOverviewButtons goToInfoUpdate={goToInfoUpdate} createNewGameBuild={createNewGameBuild} />
      </Box>
    </Box>
  );
};

export default SubmissionOverviewHeader;
